var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-resize-pad",on:{"click":function($event){$event.stopPropagation();},"mousedown":function($event){$event.stopPropagation();return _vm.start.apply(null, arguments)},"touchstart":function($event){$event.stopPropagation();return _vm.start.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }